import Vuex from 'vuex'

function myBoolean(str) {
    if (str === 'true') {
        return true
    } else {
        return false
    }
}

export default new Vuex.Store({
    state: {
        token: localStorage.getItem('token') ? localStorage.getItem('token') : '',
        userName: localStorage.getItem('userName') ? localStorage.getItem('userName') : '',
        theme: localStorage.getItem('theme') ? myBoolean(localStorage.getItem('theme')) : true,
        permissions: localStorage.getItem('permissions') ? localStorage.getItem('permissions') : [],
        roles: localStorage.getItem('roles') ? localStorage.getItem('roles') : [],
    },
    mutations: {
        setTheme(state, theme) {
            state.theme = theme

            localStorage.setItem('theme', theme)
        },
        setToken(state, token) {
            state.token = token
            localStorage.setItem('token', token)

        },
        setUserName(state, name) {
            state.userName = name
            localStorage.setItem('userName', name);
        },
        sePermissions(state, permissions) {
            state.permissions = permissions
            localStorage.setItem('permissions', JSON.stringify(permissions));
        },
        seRoles(state, roles) {
            state.roles = roles
            localStorage.setItem('roles', roles);
        },
    },
    actions: {},
    modules: {}
})
